export default "__VITE_ASSET__fPnhoK33__"